import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { updateOfferProduct } from "../../../api/offerProduct";
import {
	calculateMinutesFromTime,
	formatInstallationTime,
} from "../../../utils/helpers";
import { alertError, alertSuccess } from "../../../utils/logger";
import LoadingDialog from "./LoadingDialog";

function getEmptyOfferProduct() {
	return {
		oferta_id: null,
		revision_num: 0,
		capitulo_id: null,
		partida_id: null,
		producto_id: null,

		descripcion: null,
		referencia: null,
		plantilla_producto_original_id: null,

		tipo_producto_id: null,
		tipo_unidad_id: null,
		def_unidades: null,
		def_factor: null,
		def_precio_compra: null,
		def_descuento_proveedor: null,
		def_tiempo_mano_de_obra: null,
	};
}

const EditOfferProductDialog = (props) => {
	const { title, open, setOpen, data, onSave } = props;

	const [loading, setLoading] = useState(false);

	const [offerProduct, setOfferProduct] = useState({
		...getEmptyOfferProduct(),
		...data,
	});

	useEffect(() => {
		if (open)
			setOfferProduct({
				...getEmptyOfferProduct(),
				...data,
			});
	}, [open]);

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function saveOfferProduct() {
		const validateProduct = () => {
			let error = "";

			if (!offerProduct?.descripcion) {
				error = "La descripción es obligatoria.";
			} else if (!offerProduct?.referencia) {
				error = "La referencia es obligatoria.";
			}

			if (error) {
				alertError({
					error: error,
				});
				return false;
			}

			return true;
		};

		if (!validateProduct()) {
			return;
		}

		setLoading(true);
		updateOfferProduct(
			offerProduct?.producto_id,
			offerProduct,
			loggedUser?.accessToken
		)
			.then((res) => {
				if (res.status === 204) {
					setLoading(false);
					alertSuccess({
						title: "¡Guardado!",
						customMessage: "Cambios guardados con éxito",
					});
					onSave();
					setOpen(false);
					setOfferProduct(getEmptyOfferProduct());
				}
			})
			.catch((error) => {
				setLoading(false);
				alertError({
					error: error,
					customMessage: "No se han podido guardar los cambios",
				});
			});
	}

	const handleChange = (element) => (event) => {
		let value = event.target.value;
		if (element === "def_tiempo_mano_de_obra")
			value = calculateMinutesFromTime(value);

		setOfferProduct({ ...offerProduct, [element]: value });
	};

	return (
		<>
			<Dialog
				fullWidth={true}
				maxWidth="md"
				open={open}
				onClose={() => {
					setOpen(false);
				}}
				aria-labelledby="table-dialog"
				className="backdrop"
			>
				<DialogTitle id="table-dialog">{title}</DialogTitle>
				<DialogContent>
					<div className="row d-flex align-items-center">
						<div className="col-md-4">
							<TextField
								label="Descripción"
								value={offerProduct.descripcion}
								onChange={handleChange("descripcion")}
								InputLabelProps={{
									shrink: true,
								}}
								margin="normal"
								variant="outlined"
								required
							/>
						</div>
						<div className="col-md-4">
							<TextField
								label="Referencia"
								value={offerProduct.referencia}
								onChange={handleChange("referencia")}
								InputLabelProps={{
									shrink: true,
								}}
								margin="normal"
								variant="outlined"
								required
							/>
						</div>
						<div className="col-md-4">
							<TextField
								label="Precio compra (€)"
								value={offerProduct.def_precio_compra}
								onChange={handleChange("def_precio_compra")}
								InputLabelProps={{
									shrink: true,
								}}
								InputProps={{
									inputProps: {
										min: 0,
									},
								}}
								type="number"
								margin="normal"
								variant="outlined"
								required
							/>
						</div>
					</div>
					<div className="row d-flex align-items-center">
						<div className="col-md-3">
							<TextField
								label="Unidades"
								value={offerProduct.def_unidades}
								onChange={handleChange("def_unidades")}
								InputLabelProps={{
									shrink: true,
								}}
								InputProps={{
									inputProps: {
										min: 0,
									},
								}}
								type="number"
								margin="normal"
								variant="outlined"
								required
							/>
						</div>
						<div className="col-md-3">
							<TextField
								label="Factor (%)"
								value={offerProduct.def_factor}
								onChange={handleChange("def_factor")}
								InputLabelProps={{
									shrink: true,
								}}
								InputProps={{
									inputProps: {
										min: 1,
									},
								}}
								type="number"
								margin="normal"
								variant="outlined"
								required
							/>
						</div>

						<div className="col-md-3">
							<TextField
								label="Descuento proveedor (%)"
								value={offerProduct.def_descuento_proveedor}
								onChange={handleChange(
									"def_descuento_proveedor"
								)}
								InputLabelProps={{
									shrink: true,
								}}
								InputProps={{
									inputProps: {
										min: 0,
									},
								}}
								type="number"
								margin="normal"
								variant="outlined"
								required
							/>
						</div>
						<div className="col-md-3">
							<TextField
								label="Tiempo (hh:mm)"
								value={formatInstallationTime(
									offerProduct.def_tiempo_mano_de_obra
								)}
								onChange={handleChange(
									"def_tiempo_mano_de_obra"
								)}
								InputLabelProps={{
									shrink: true,
								}}
								InputProps={{
									inputProps: {
										min: 0,
									},
								}}
								type="time"
								margin="normal"
								variant="outlined"
								required
							/>
						</div>
					</div>
				</DialogContent>
				<DialogActions>
					<Button
						className="mr-2"
						onClick={() => {
							setOpen(false);
							setOfferProduct(getEmptyOfferProduct());
						}}
						variant="outlined"
					>
						Cancelar
					</Button>
					<Button
						onClick={() => {
							saveOfferProduct();
						}}
						variant="outlined"
						color="primary"
					>
						Guardar
					</Button>
					<br />
				</DialogActions>
			</Dialog>
			<LoadingDialog open={loading} />
		</>
	);
};
export default EditOfferProductDialog;
